const defaultState = {
    data : {}
  };
  
  export default (state = defaultState, action) => {
    switch (action.type) {
      case 'UPDATE_FORM':
        return {
          ...state,
          data: action.payload
        };
    case 'GET_DATA':
        return {
            ...state
        }
      default:
        return {
          ...state
        };
    }
  };
  